module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25784",
      "conversations-internal-schema": "static-1.12430",
      "head-dlb": "static-1.4754",
      "hs-test-utils": "static-1.7773",
      "hubspot-url-utils": "static-1.3927",
      "HubStyleTokens": "static-2.11187",
      "I18n": "static-7.1561",
      "jasmine-runner": "static-1.6241",
      "quartz": "static-1.6683",
      "react": "static-7.178",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.483",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5898",
      "enviro": "static-4.387",
      "hs-promise-rejection-tracking": "static-1.5291",
      "PortalIdParser": "static-2.349",
      "raven": "static-3.5624",
      "raven-hubspot": "static-1.5931",
      "bend-plugin-trellis-migration": "static-1.3195",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17616",
      "cv-backend-services": "static-1.1488",
      "hub-http": "static-1.5966",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4421",
      "quartz-config": "static-1.461",
      "quartz-core": "static-1.5902",
      "transmute": "static-2.85",
      "HeadJS": "static-2.703",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7460",
      "framer-motion": "static-1.67",
      "hs-test-utils-bend-plugin": "static-1.2884",
      "msw": "static-1.39",
      "react-redux": "static-7.67",
      "redux": "static-4.16",
      "testing-library": "static-1.147",
      "foundations-theming": "static-1.4176",
      "i18n-data": "static-1.216",
      "metrics-js": "static-1.9404",
      "moment-timezone": "static-5.78",
      "react-utils": "static-2.5144",
      "jasmine": "static-4.4098",
      "history": "static-4.47",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.61",
      "styled-components": "static-2.85",
      "UIComponents": "static-3.8134",
      "visitor-ui-component-library-icons": "static-1.5709",
      "bender-build-tools": "static-1.2903",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4417",
      "apollo-stack-hubspot": "static-3.81",
      "classnames": "static-2.10",
      "cssUtils": "static-1.723",
      "customer-data-objects": "static-1.7412",
      "customer-data-ui-utilities": "static-1.9592",
      "data-fetching-client": "static-1.9445",
      "FileManagerCore": "static-1.38292",
      "FileManagerLib": "static-1.38433",
      "foundations-assets": "static-1.4600",
      "graphql": "static-1.77",
      "hs-promise-utils": "static-1.5359",
      "hubspot-apollo-client": "static-1.4647",
      "icons": "static-2.618",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.94",
      "rpc-client-utils": "static-1.4399",
      "salesImages": "static-1.520",
      "timezone-utils": "static-2.5012",
      "ui-gdpr-components": "static-1.10114",
      "ts-schema": "static-1.3874",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.130",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.786",
      "hubspotter-http": "static-1.4448",
      "mobile-manifest-mixins": "static-1.476",
      "module-federation": "static-1.18",
      "quartz-auth": "static-1.358",
      "quartz-head": "static-1.348",
      "quartz-i18n": "static-1.358",
      "quartz-routing": "static-1.113",
      "quartz-test": "static-1.358",
      "quick-fetch": "static-1.3703",
      "react-rhumb": "static-1.16408",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.449",
      "usage-tracker-container": "static-1.7091",
      "bend-plugin-foundations-components": "static-1.3729",
      "floating-ui": "static-1.51",
      "foundations-theming-specialty": "static-1.1892",
      "hs-story-utils": "static-1.9196",
      "tanstack-table": "static-1.50",
      "trellis-assets": "static-1.1101",
      "ui-images": "static-2.1083",
      "bend-plugin-foundations-theming": "static-1.2659",
      "foundations-theming-base": "static-1.3161",
      "stylex": "static-1.27",
      "HubStyle": "static-2.11495",
      "sassPrefix": "static-1.151",
      "inbound-db-properties-service-client": "static-1.3646",
      "property-translator": "static-1.5181",
      "react-dnd-compat": "static-1.4391",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8264",
      "audio-components": "static-1.5565",
      "cropperjs": "static-1.10",
      "file-manager-components": "static-1.22793",
      "FileManagerImages": "static-1.35944",
      "immerable": "static-1.3922",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8647",
      "urlinator": "static-1.4302",
      "usage-tracker-core": "static-1.6951",
      "video-components": "static-1.12482",
      "video-data-lib": "static-1.34137",
      "video-embed": "static-1.34971",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.106",
      "hub-http-shared-msw-handlers": "static-1.9400",
      "hubspotter-http-shared-msw-handlers": "static-1.9398",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20184",
      "chirp-fetch": "static-1.1651",
      "ContentUtils": "static-1.67527",
      "copilot-toolkit": "static-1.10442",
      "sanitize": "static-1.4242",
      "sanitize-text": "static-1.7908",
      "content-assistance-lib": "static-1.7400",
      "usage-tracker": "static-1.7101",
      "video-components-external": "static-1.10479",
      "unified-auth-core-lib": "static-1.442",
      "content-icons-ui": "static-1.2144",
      "social-insights-client-types": "static-1.21264",
      "SharedI18nStrings": "static-1.180",
      "outpost": "static-1.3975",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4574",
      "integrations-lib": "static-1.15313",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5362",
      "magpie-types": "static-1.4822",
      "simple-logging-lib": "static-1.2818",
      "superstore": "static-1.4539",
      "ui-addon-video-player": "static-1.8463",
      "ui-coaching-tips": "static-1.27859",
      "content-media-composition-data-lib": "static-1.11335",
      "content-media-compositions": "static-2.15342",
      "idb-keyval": "static-1.39",
      "media-bridge-lib": "static-1.18513",
      "fsm": "static-1.3499",
      "flux-actions": "static-1.304",
      "frontend-preferences-client": "static-1.7691",
      "integrations-error-boundary-lib": "static-1.12728",
      "integrations-tracking-lib": "static-1.5351",
      "laboratory-lib": "static-3.6930",
      "native-integrations-shared-strings": "static-1.7556",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10140",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.10899",
      "ui-shepherd-react": "static-3.9912",
      "reactive-lib": "static-1.494",
      "growth-onboarding-feedback-components": "static-1.6353",
      "hls.js": "static-1.34",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2763",
      "foundations-components-test-utils": "static-1.4943",
      "react-dlb": "static-1.71",
      "crm-record-cards-service-types": "static-1.3422",
      "framework-data-schema-resolvers": "static-1.6637",
      "location-customization-utils-lib": "static-1.8455",
      "batch-promise": "static-1.1318",
      "conditional-properties-service-client": "static-1.3594",
      "crm-pipelines-api-client-types": "static-1.3935",
      "framework-builder-read-service-client": "static-1.3817",
      "framework-data-schema-quick-fetch": "static-1.6542",
      "inbound-db-meta-service-client": "static-1.3397",
      "multi-currency-client-types": "static-1.3488",
      "persist-promise": "static-1.3475"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25784",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12430",
      "head-dlb": "/head-dlb/static-1.4754",
      "hs-test-utils": "/hs-test-utils/static-1.7773",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3927",
      "HubStyleTokens": "/HubStyleTokens/static-2.11187",
      "I18n": "/I18n/static-7.1561",
      "jasmine-runner": "/jasmine-runner/static-1.6241",
      "quartz": "/quartz/static-1.6683",
      "react": "/react/static-7.178",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.483",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5898",
      "enviro": "/enviro/static-4.387",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
      "PortalIdParser": "/PortalIdParser/static-2.349",
      "raven": "/raven/static-3.5624",
      "raven-hubspot": "/raven-hubspot/static-1.5931",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17616",
      "cv-backend-services": "/cv-backend-services/static-1.1488",
      "hub-http": "/hub-http/static-1.5966",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4421",
      "quartz-config": "/quartz-config/static-1.461",
      "quartz-core": "/quartz-core/static-1.5902",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.703",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7460",
      "framer-motion": "/framer-motion/static-1.67",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2884",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.67",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.147",
      "foundations-theming": "/foundations-theming/static-1.4176",
      "i18n-data": "/i18n-data/static-1.216",
      "metrics-js": "/metrics-js/static-1.9404",
      "moment-timezone": "/moment-timezone/static-5.78",
      "react-utils": "/react-utils/static-2.5144",
      "jasmine": "/jasmine/static-4.4098",
      "history": "/history/static-4.47",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.61",
      "styled-components": "/styled-components/static-2.85",
      "UIComponents": "/UIComponents/static-3.8134",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5709",
      "bender-build-tools": "/bender-build-tools/static-1.2903",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4417",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.723",
      "customer-data-objects": "/customer-data-objects/static-1.7412",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9592",
      "data-fetching-client": "/data-fetching-client/static-1.9445",
      "FileManagerCore": "/FileManagerCore/static-1.38292",
      "FileManagerLib": "/FileManagerLib/static-1.38433",
      "foundations-assets": "/foundations-assets/static-1.4600",
      "graphql": "/graphql/static-1.77",
      "hs-promise-utils": "/hs-promise-utils/static-1.5359",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4647",
      "icons": "/icons/static-2.618",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.94",
      "rpc-client-utils": "/rpc-client-utils/static-1.4399",
      "salesImages": "/salesImages/static-1.520",
      "timezone-utils": "/timezone-utils/static-2.5012",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10114",
      "ts-schema": "/ts-schema/static-1.3874",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.130",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.786",
      "hubspotter-http": "/hubspotter-http/static-1.4448",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.476",
      "module-federation": "/module-federation/static-1.18",
      "quartz-auth": "/quartz-auth/static-1.358",
      "quartz-head": "/quartz-head/static-1.348",
      "quartz-i18n": "/quartz-i18n/static-1.358",
      "quartz-routing": "/quartz-routing/static-1.113",
      "quartz-test": "/quartz-test/static-1.358",
      "quick-fetch": "/quick-fetch/static-1.3703",
      "react-rhumb": "/react-rhumb/static-1.16408",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.449",
      "usage-tracker-container": "/usage-tracker-container/static-1.7091",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3729",
      "floating-ui": "/floating-ui/static-1.51",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1892",
      "hs-story-utils": "/hs-story-utils/static-1.9196",
      "tanstack-table": "/tanstack-table/static-1.50",
      "trellis-assets": "/trellis-assets/static-1.1101",
      "ui-images": "/ui-images/static-2.1083",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2659",
      "foundations-theming-base": "/foundations-theming-base/static-1.3161",
      "stylex": "/stylex/static-1.27",
      "HubStyle": "/HubStyle/static-2.11495",
      "sassPrefix": "/sassPrefix/static-1.151",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3646",
      "property-translator": "/property-translator/static-1.5181",
      "react-dnd-compat": "/react-dnd-compat/static-1.4391",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8264",
      "audio-components": "/audio-components/static-1.5565",
      "cropperjs": "/cropperjs/static-1.10",
      "file-manager-components": "/file-manager-components/static-1.22793",
      "FileManagerImages": "/FileManagerImages/static-1.35944",
      "immerable": "/immerable/static-1.3922",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8647",
      "urlinator": "/urlinator/static-1.4302",
      "usage-tracker-core": "/usage-tracker-core/static-1.6951",
      "video-components": "/video-components/static-1.12482",
      "video-data-lib": "/video-data-lib/static-1.34137",
      "video-embed": "/video-embed/static-1.34971",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.106",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9400",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9398",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20184",
      "chirp-fetch": "/chirp-fetch/static-1.1651",
      "ContentUtils": "/ContentUtils/static-1.67527",
      "copilot-toolkit": "/copilot-toolkit/static-1.10442",
      "sanitize": "/sanitize/static-1.4242",
      "sanitize-text": "/sanitize-text/static-1.7908",
      "content-assistance-lib": "/content-assistance-lib/static-1.7400",
      "usage-tracker": "/usage-tracker/static-1.7101",
      "video-components-external": "/video-components-external/static-1.10479",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.442",
      "content-icons-ui": "/content-icons-ui/static-1.2144",
      "social-insights-client-types": "/social-insights-client-types/static-1.21264",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "outpost": "/outpost/static-1.3975",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4574",
      "integrations-lib": "/integrations-lib/static-1.15313",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5362",
      "magpie-types": "/magpie-types/static-1.4822",
      "simple-logging-lib": "/simple-logging-lib/static-1.2818",
      "superstore": "/superstore/static-1.4539",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8463",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27859",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11335",
      "content-media-compositions": "/content-media-compositions/static-2.15342",
      "idb-keyval": "/idb-keyval/static-1.39",
      "media-bridge-lib": "/media-bridge-lib/static-1.18513",
      "fsm": "/fsm/static-1.3499",
      "flux-actions": "/flux-actions/static-1.304",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7691",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12728",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5351",
      "laboratory-lib": "/laboratory-lib/static-3.6930",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7556",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10140",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10899",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9912",
      "reactive-lib": "/reactive-lib/static-1.494",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6353",
      "hls.js": "/hls.js/static-1.34",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2763",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4943",
      "react-dlb": "/react-dlb/static-1.71",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3422",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6637",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8455",
      "batch-promise": "/batch-promise/static-1.1318",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3594",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3935",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6542",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3488",
      "persist-promise": "/persist-promise/static-1.3475"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};